import * as React from "react"
import { actions, AppState } from "../data/redux-state"
import { globalStore } from "./Index"
import { FormattedMessage, useIntl } from "gatsby-plugin-intl"
import { useTheme } from "@mui/material/styles"
import OutlinedInput from "@mui/material/OutlinedInput"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import Select from "@mui/material/Select"
import { translateGeoRegion } from "../utils/translateGeoRegion"
import checkSubVars from "../utils/checkSubVars"

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

function getStyles(name: string, personName: string[], theme: any) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  }
}

function getRegionArray(appState: AppState) {
  const sourceJson = appState.sourceJson
  // const subVariable = appState.subVariable
  if (!sourceJson) {
    return []
  }
  const subvars = checkSubVars(sourceJson)
  if (!subvars) {
    return []
  }
  const regions = subvars[Object.keys(subvars)[0]].GeoRegions

  let regionsNames = []
  for (let name in regions) {
    regionsNames.push(name)
  }
  return regionsNames
}

export const MultiRegionsDropdown = (props: AppState) => {
  const theme = useTheme()
  const intl = useIntl()

  const [geoRegions, setGeoRegions] = React.useState(props.geoRegion)

  React.useEffect(() => {
    setGeoRegions(props.geoRegion)
  }, [props.subVariable])

  const handleChange = async (event: any) => {
    const {
      target: { value },
    } = event
    globalStore.dispatch(
      actions.setGeoRegion(typeof value === "string" ? value.split(",") : value)
    )
  }

  return (
    <>
      <FormControl style={{ width: "80%", marginTop: "10px" }}>
        <InputLabel
          style={{ backgroundColor: "white", left: "-13px" }}
          id="georegion-native-helper"
        >
          <FormattedMessage id={"dropdown.selectRegion"} />
        </InputLabel>
        <Select
          value={props.geoRegion ?? []}
          onChange={handleChange}
          id="georegion-native-helper"
          name="georegion"
          multiple
          input={<OutlinedInput label="Region" />}
          MenuProps={MenuProps}
          style={{ textAlign: "left", paddingLeft: 0 }}
        >
          {getRegionArray(props).map((region: string, index: number) => {
            return (
              <MenuItem
                key={region}
                value={region}
                style={getStyles(region, props.geoRegion, theme)}
              >
                {translateGeoRegion(region, intl)}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </>
  )
}
